<template>
    <div class="modal" :id="compModalIdentifier" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        Create Fuel Expense
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light" style="">
                    <fieldset>

                        <div class="row">
                            <div class="col-12">
                                <AdminBlock>
                                    <MovementSelect
                                        :movements="movements"
                                        :job="job"
                                        remove-margin
                                        required
                                        @update-movement="updateMovement"
                                    />
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">

                                    <AdminBlock
                                        title="Expense"
                                    >

                                        <InputTextField
                                            name="Label"
                                            label="label"
                                            placeholder="Label"
                                            required
                                            v-model="label"
                                        />

                                        <InputNumberField
                                            name="fuel"
                                            label="Fuel (Optional)"
                                            placeholder="Fuel"
                                            append="Litres"
                                            v-model="fuel"
                                        />

                                        <div class="">

                                            <div class="mb-2">
                                                <input
                                                    type="checkbox"
                                                    :name="compEvidenceReceived"
                                                    :id="compEvidenceReceived"
                                                    v-model="evidenceReceived"
                                                >
                                                <label :for="compEvidenceReceived">
                                                    <strong>
                                                        Evidence Received (If assigned to Driver)
                                                    </strong>
                                                </label>
                                            </div>

                                            <div>
                                                <input
                                                    type="checkbox"
                                                    :name="compRechargeClient"
                                                    :id="compRechargeClient"
                                                    v-model="rechargeClient"
                                                >
                                                <label :for="compRechargeClient">
                                                    <strong>
                                                        Recharge Client
                                                    </strong>
                                                </label>
                                            </div>
                                        </div>

                                    </AdminBlock>

                                    <AdminBlock
                                        title="Driver"
                                        class="mb-0"
                                    >

                                        <p>
                                            If the Expense was incurred by a Driver and needs paying back to them, please select them below.
                                        </p>

                                        <DriverSelect
                                            removeMargin
                                            :driver="selectedDriver"
                                            @update-driver="updateDriver"
                                        />

                                    </AdminBlock>

                            </div>

                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Cost"
                                >
                                    <div class="mb-4">
                                        <label for="">
                                            <strong>
                                                Payment Method
                                            </strong>
                                        </label>

                                        <v-select
                                            :options="[
                                                'Cash',
                                                'Card',
                                                'By Admin'
                                            ]"
                                            placeholder="Payment Method"
                                            v-model="selectedPaymentMethod"
                                        ></v-select>
                                    </div>

                                    <InputTextField
                                        name="total"
                                        label="Total (Optional if fuel)"
                                        prepend="£"
                                        v-model="total"
                                        placeholder="0.00"
                                        removeMargin
                                    />

                                </AdminBlock>

                                <AdminBlock
                                    title="Images"
                                    class="mb-0"
                                >

                                    <p class="mb-0">
                                        Please upload your receipts where possible
                                    </p>

                                    <FileUpload
                                        name="receipt_file_signature"
                                        :file-upload-route="getExpenseModalFileUploadRoute()"
                                        no-label
                                        no-margin
                                        @file-uploaded="handleReceiptSignature"
                                    />

                                </AdminBlock>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            :id="'create_' + getModalType() + 'contact_close_button'"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewExpense()" >Save</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import Swal from "sweetalert2";
    import VSelect from 'vue-select';
    import AdminBlock from "@/components/movements/components/AdminBlock.vue";
    import inputTextField from "@/components/movements/components/InputTextField.vue";
    import driverSelect from "@/components/movements/components/DriverSelect.vue";
    import InputNumberField from "@/components/movements/components/InputNumberField.vue";
    import FileUpload from "@/components/movements/components/FileUpload.vue";
    import MovementSelect from "@/components/movements/components/MovementSelect.vue";

    export default {

        components: {
            MovementSelect,
            FileUpload,
            InputNumberField,
            AdminBlock,
            VSelect,
            inputTextField,
            driverSelect,
        },

        props: {
            movements: {
                type: Array,
                default: () => [],
                required: false,
            },
            job: {
                type: Object,
                default: () => {},
                required: false,
            },
            identifier: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                label: '',
                fuel: '',

                selectedDriver: null,
                selectedMovement: null,

                selectedPaymentMethod: '',
                total: '',

                evidenceReceived: false,
                rechargeClient: false,

                receiptFileSignature: '',
            }
        },

        methods: {

            getModalType () {
                return this.modalFor !== '' ? this.modalFor + '_' : ''
            },

            handleReceiptSignature (signature) {
                this.receiptFileSignature = signature;
            },

            resetForm() {
                this.label = '';
                this.fuel = null;

                this.selectedDriver = null;

                this.selectedPaymentMethod = '';
                this.total = null;

                this.evidenceReceived = false;
                this.rechargeClient = false;

                this.receiptFileSignature = '';
            },

            createNewExpense () {

                const data = {
                    movement_id: this.selectedMovement?.id,
                    driver_id: this.selectedDriver?.id,
                    label: this.label,

                    payment_method: this.selectedPaymentMethod,

                    evidence_received: this.evidenceReceived,
                    recharge_client: this.rechargeClient,

                    fuel: this.fuel || null,
                    total: this.total || null,

                    receipt_file_signature: this.receiptFileSignature || null,
                };

                axios.post( route('api.movements.expenses.store'), data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                })
                    .then(response => {

                        this.$emit('fuel-created', response.data);

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: "Success!",
                            text: "Expense Created!",
                            timer: 3000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                        });

                        this.resetForm();

                        window.jQuery('.modal-header .btn-close').click();

                    })
                    .catch(error => {

                        const errorMessages = error.response?.data?.errors || {};
                        const allErrors = Object.values(errorMessages)
                            .flat()
                            .map(msg => `<p class="mb-0">${msg}</p>`)
                            .join('');

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'error',
                            title: "Error Creating Fuel Expense",
                            html: allErrors || 'An error occurred',
                            timer: 3000,
                            showConfirmButton: false,
                        });

                    });

            },

            updateDriver ( value ) {
                this.selectedDriver = value;
            },

            updateMovement ( value ) {
                this.selectedMovement = value;
                this.selectedDriver = value ? value.driver : null;
            },

            getExpenseModalFileUploadRoute() {
                return route('api.movements.expenses.get-upload-url');
            },

        },

        computed: {
            compModalIdentifier() {
                return this.identifier + '_fuel_modal';
            },
            compEvidenceReceived() {
                return this.identifier + '_evidence_received';
            },
            compRechargeClient() {
                return this.identifier + '_recharge_client';
            },
        },

        watch: {
            expense(expense) {
                if (expense) {
                    this.label = expense.label;
                    this.reference = expense.reference;
                    this.fuel = expense.fuel;
                    this.evidenceReceived = expense.evidence_received;
                    this.rechargeClient = expense.recharge_client;
                    this.selectedMovement = expense.movement;
                    this.selectedDriver = expense.driver;
                    this.selectedPaymentMethod = expense.payment_method;
                    this.total = expense.total;
                }
            }
        },

    }

</script>
